export const CHANGE_SEARCH_VALUE = "CHANGE_SEARCH_VALUE";

export const REQUEST_API_PENDING = "REQUEST_API_PENDING";
export const REQUEST_API_SUCCESS = "REQUEST_API_SUCCESS";
export const REQUEST_API_FAILED = "REQUEST_API_PENDING";

export const VIEW_PROFILE = "VIEW_PROFILE";

export const CHANGE_ACTIVE_PAGE = "CHANGE_ACTIVE_PAGE";
